/* global mainScript */
import React, { useState } from "react";
import PropTypes from "prop-types";
import styled from "@emotion/styled";
import { motion } from "framer-motion";
import { useMediaQuery } from "react-responsive";

//style rules
import { Sizes, Animation, Colors } from "../../styles";

import SidePanelCard from "./SidePanelCard";
import SidePanelDots from "./SidePanelDots";

const SidePanel = ({ toggleSidePanel, selectedContent, handleNext, handlePrevious, isNextDisabled, isPreviousDisabled, numOfSlides, selectedSlide, handleSelectSlide }) => {
	const [direction, setDirection] = useState(0);

	const isDesktop = useMediaQuery({
		query: `(min-width: ${Sizes.screens.large})`,
	});

	const handleSelectRadio = (index) => {
		// based on index, find out which direction the animation will go
		const currentIndex = selectedContent.index;
		const direction = index > currentIndex ? 1 : -1;
		setDirection(direction);

		handleSelectSlide(index);
	};
	const handlePressNext = () => {
		setDirection(1);
		handleNext();
	};

	const handlePressPrevious = () => {
		setDirection(-1);
		handlePrevious();
	};

	return (
		<>
			<Overlay initial={"closed"} animate={"opened"} exit={"closed"} variants={Animation.sidepanel.overlayVariants} onClick={() => toggleSidePanel()} />
			<Aside
				id={"panel"}
				role="dialog"
				initial={{ width: 0, opacity: 0 }}
				animate={{ width: isDesktop ? 949 : "100vw", opacity: 1, transition: { delay: 0.3 } }}
				exit={{
					width: 0,
					opacity: 0,
					transition: { delay: 0.5 },
				}}>
				<PanelContainer
					initial="closed" animate="open" exit="closed" variants={Animation.sidepanel.opacityVariants}>
					<CloseIcon
						aria-label={"close panel"}
						aria-controls={"panel"}
						icon={mainScript.assetPath + "images/svg/icons/icon-close.svg"}
						onClick={() => toggleSidePanel()}
						onKeyDown={() => toggleSidePanel()}
						tabIndex={0}
					/>
					{!!isDesktop && handleNext && handlePrevious && (
						<ButtonContainer>
							<Button icon={mainScript.assetPath + "images/svg/icons/icon-arrow.svg"} className="previous" disabled={isPreviousDisabled} onClick={handlePressPrevious}></Button>
							<Button icon={mainScript.assetPath + "images/svg/icons/icon-arrow.svg"} className="next" disabled={isNextDisabled} onClick={handlePressNext}></Button>
						</ButtonContainer>
					)}

					<SidePanelCard content={selectedContent} direction={direction} handlePressNext={handlePressNext} handlePressPrevious={handlePressPrevious} />
				</PanelContainer>
				{!isDesktop && <SidePanelDots numOfSlides={numOfSlides} isSelected={selectedSlide} handleSelectSlide={handleSelectRadio} />}
			</Aside>
		</>
	);
};

export default SidePanel;

SidePanel.propTypes = {
	toggleSidePanel: PropTypes.func,
	selectedContent: PropTypes.object,
};

const Aside = styled(motion.aside)`
	background-color: ${Colors.base.white};
	position: fixed;
	right: 0;
	top: 0;
	height: 100vh;
	height: 100svh;
	overflow: visible;
	z-index: 1000;
	padding: 9.2rem 1.6rem 9.2rem;

	@media only screen and (min-width: ${Sizes.screens.medium}) {
		padding: 8.5rem 0 5rem;
		width: 100%;
	}
`;

const PanelContainer = styled(motion.div)`
	height: 100%;
	overflow: scroll;

	@media only screen and (min-width: ${Sizes.screens.medium}) {
		padding: 0 10rem;
		width: 100%;
	}
`;

const CloseIcon = styled(motion.svg)`
	position: absolute;
	right: 2.5rem;
	top: 2.5rem;
	content: "";
	z-index: 901;
	background: url(${(props) => props.icon && props.icon}) no-repeat;
	width: 40px;
	height: 40px;
	margin: 0.4rem 0 0 0.5rem;
	cursor: pointer;

	@media only screen and (min-width: ${Sizes.screens.medium}) {
		right: 5rem;
		top: 5rem;
	}
`;

const Overlay = styled(motion.div)`
	position: fixed;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	cursor: pointer;
	width: 100vw;
	height: 100vh;
	z-index: 900;
	background: ${Colors.base.black};
	opacity: 0.5;
`;
const ButtonContainer = styled.div`
	position: absolute;
	top: 4rem;
	left: 0;
	width: 100%;
	display: flex;
	gap: 4rem;
	justify-content: center;
	z-index: 2;

	@media screen and (min-width: ${Sizes.screens.medium}) {
		top: 50%;
		justify-content: space-between;
		padding: 0 1rem;
		gap: 0;
	}
`;
const Button = styled.button`
	all: unset;
	transform-origin: center;
	background: url(${(props) => props.icon && props.icon}) no-repeat center;
	width: 13px;
	height: 20px;
	padding: 1rem 1.3rem;

	cursor: pointer;

	&.previous {
		rotate: 180deg;
	}
	&.next {
	}

	&:hover,
	&:active,
	&:focus {
		background-color: transparent;
	}
	&:hover {
		scale: 1.1;
	}
	&:focus {
		box-shadow: none;
	}
	&:disabled {
		pointer-events: none;
		opacity: 0.3;
	}
`;
